import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_14: FaireProductEntity = {
  token: "sweet-wink-14",
  type: "product",
  name: "Red Glitter Bow Baby Headband - Hair Bows - Holiday",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/1beeee6cc858aad5f3b3eb2de1bfe630a3549fdb4fb732da4d5c3797392c4829.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 8,
  msrpDollars: 16,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
